export const GET_SINGLE_DELIVERY_ORDER = "GET_SINGLE_DELIVERY_ORDER";
export const CLEAR_SINGLE_DELIVERY_ORDER = "CLEAR_SINGLE_DELIVERY_ORDER";
